import React from 'react';
import POICard from './POICard';

const POIList = ({ 
  poiList, 
  filteredPoiList, 
  selectedPoi, 
  isLoadingPois, 
  selectedDuration, 
  onPoiSelect 
}) => {
  if (isLoadingPois) {
    return (
      <div style={{ textAlign: 'center', padding: '20px', color: '#666' }}>
        Loading places...
      </div>
    );
  }

  if (!selectedDuration) {
    return (
      <div style={{ textAlign: 'center', padding: '20px', color: '#666' }}>
        Please select a duration to see nearby places.
      </div>
    );
  }

  if (filteredPoiList.length === 0) {
    return (
      <div style={{ textAlign: 'center', padding: '20px', color: '#666' }}>
        {poiList.length > 0 ? 'No places match your current filter.' : 'No places found in this area.'}
      </div>
    );
  }

  return (
    <div>
      {filteredPoiList.map((poi, idx) => (
        <POICard
          key={idx}
          poi={poi}
          isActive={selectedPoi && selectedPoi.poi_name === poi.poi_name}
          onClick={onPoiSelect}
        />
      ))}
    </div>
  );
};

export default POIList; 